












































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  CHANGE_USER_DATA_CLEANSING_LOADING,
  GET_USER_DETAILS,
  SET_CHANGE_USER_DATA_CLEANSING_LOADING,
  SET_USER_DATA_CLEANSING_ERRORS,
  SET_USER_PERFORM_DATA_CLEANSING,
  UPDATE_USER_DETAILS,
  USER_DATA_CLEANSING_ERRORS,
  USER_PERFORM_DATA_CLEANSING,
} from '@/types/lobby.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { UserData } from '@/models/UserDetails.model';

@Component({})
export default class UserDataCleansingModal extends Vue {

  @Inject() public $validator;

  @Action(GET_USER_DETAILS, StoreNamespace.LOBBY) public getUserDetails;
  @Action(UPDATE_USER_DETAILS, StoreNamespace.LOBBY) public updateUserDetails;

  @Mutation(SET_USER_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public setUserPerformDataCleansing;
  @Mutation(SET_USER_DATA_CLEANSING_ERRORS, StoreNamespace.LOBBY) public setUserDataCleansingErrors;
  @Mutation(SET_CHANGE_USER_DATA_CLEANSING_LOADING, StoreNamespace.LOBBY) public setChangeUserDataCleansingLoading;

  @Getter(USER_DATA_CLEANSING_ERRORS, StoreNamespace.LOBBY) public userDataCleansingErrors!: string[];
  @Getter(USER_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public userPerformDataCleansing!: boolean;
  @Getter(CHANGE_USER_DATA_CLEANSING_LOADING, StoreNamespace.LOBBY) public changeUserDataCleansingLoading!: boolean;

  public userData: UserData = {};

  public created() {
    this.getUserDetails()
        .then((data: UserData) => {
          this.userData = {
            email: data.emailAddress,
            phone: data.telephone,
          };
        });
    this.setUserDataCleansingErrors([]);
    this.setChangeUserDataCleansingLoading(false);
  }

  public mounted() {
    this.setUserDataCleansingErrors([]);
    this.setChangeUserDataCleansingLoading(false);
  }

  public onSubmit() {
    this.setChangeUserDataCleansingLoading(true);
    this.setUserDataCleansingErrors([]);
    this.updateUserDetails({
      requestBody: this.userData,
    });
  }

  public closeDialog(): void {
    this.setUserPerformDataCleansing(false);
    this.$emit('onCancel');
  }

  public destroyed() {
    this.setUserPerformDataCleansing(false);
  }
}
